var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"background-img",class:{'background-transition': _vm.transition},attrs:{"src":_vm.backgrounds[_vm.index]}})}
var staticRenderFns = []

export { render, staticRenderFns }